import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { isSafariUserAgent } from '@/app/utils/safari-browser';
export const isServer = typeof window === 'undefined';
const getUserAgent = () => navigator?.userAgent ?? '';
export const isFirefoxBrowser = !isServer && getUserAgent().toLowerCase().includes('firefox');
export const isIOSDevice = !isServer && /iPad|iPhone/.test(getUserAgent());
export const isMac = !isServer && /Macintosh/.test(getUserAgent());
export function useLineBrowser() {
  const $ = _c(2);
  const [isLine, setIsLine] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsLine(getUserAgent().includes("Line"));
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isLine;
}
export function useSafariBrowser() {
  const isBrowser = typeof window !== 'undefined' && typeof navigator !== 'undefined';
  return isBrowser && isSafariUserAgent(getUserAgent());
}
export function useChromeBrowser() {
  const isBrowser = typeof window !== 'undefined' && typeof navigator !== 'undefined';
  const isChrome = isBrowser && /Chrome/.test(getUserAgent()) && !/Edge|OPR/.test(getUserAgent());
  return isChrome;
}
export const getIOSVersion = () => {
  if (!isIOSDevice) return 0;
  const match = getUserAgent().match(/OS (\d+)_/);
  return match ? +match[1] : 0;
};